<template>
    <div>
        <a ref="trigger-toast-warning-top" data-toast="toast-top-2" href="#"></a>

        <!--Warning Toast Bar-->
        <div id="toast-top-2" :class="{ 'show' : errors.hasOwnProperty('message') }" class="toast toast-bar toast-top rounded-l bg-red-dark shadow-bg shadow-bg-s" data-bs-delay="3000">
            <div class="align-self-center">
                <i class="icon icon-s bg-white color-red-dark rounded-l shadow-s bi bi-exclamation-triangle-fill font-22 me-3"></i>
            </div>
            <div class="align-self-center">
                <!-- mb-n2 -->
                <strong v-if="errors.hasOwnProperty('message')" class="font-13">{{ errors.message }}</strong>
                <div v-if="errors.errors">
                    <div v-for="(list_error, key_error) in errors.errors" :key="key_error">
                        <span v-for="(item, index) in list_error" :key="index" class="font-10 mt-n1 opacity-70">{{ item }}</span>
                    </div>
                </div>
            </div>
            <div class="align-self-center ms-auto">
                <button @click="hideError" type="button" class="btn-close btn-close-white me-2 m-auto font-9" data-bs-dismiss="toast"></button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex'

export default {
    name: 'warningToastBar',
    data() {
        return {
            
        }
    },
    created() {

    },
    methods: {
        ...mapMutations(['CLEAR_ERRORS']),
        hideError() {
            this.CLEAR_ERRORS()
        }
    },
    computed: {
        ...mapState({
            errors: state => state.errors,
        }),
    }
    
}
</script>

<style scoped>
.toast-bar { width: 300px; }
</style>